declare global {
  interface Window {
    currentIndex: number;
  }
}

// Get slides switches
const sliderSwitches = document.querySelectorAll(
  '.reference-modal__switch',
) as NodeListOf<HTMLElement>;
let slides: NodeListOf<HTMLElement>;
window.currentIndex = 0;
const closeButton = document.getElementById('reference-modal-close-button');

/**
 * Set the position of the close button to
 * the top right of supplied image.
 *
 * @param  {HTMLElement} activeImage
 */
function positionCloseButton(activeImage: HTMLElement) {
  const { x, y, width, height } = activeImage.getBoundingClientRect();

  if (height) {
    closeButton.style.left = `${x + width}px`;
    closeButton.style.top = `${y}px`;
  } else {
    activeImage.addEventListener('load', () => {
      const { x, y, width, height } = activeImage.getBoundingClientRect();
      closeButton.style.left = `${x + width}px`;
      closeButton.style.top = `${y}px`;
    });
  }
}

/**
 * Initialize the image 'slider' when
 * muliple images are used
 *
 * @param {HTMLElement} modal
 */
function initSlider(modal: HTMLElement) {
  // Get slides
  slides = modal.querySelectorAll('.reference-modal__image--gallery') as NodeListOf<HTMLElement>;
  positionCloseButton(slides[0]);
}

/**
 * Change the currently active image
 *
 * @param  {number} nextIndex
 * @returns {number} New current index
 */
function changeActiveImage(nextIndex: number) {
  // Hide current item
  slides[window.currentIndex].dataset.active = 'false';

  // Show next item
  slides[nextIndex].dataset.active = 'true';

  // Change the position of the close button
  positionCloseButton(slides[nextIndex]);

  // Return new current index
  return nextIndex;
}

/**
 * Go to the next element in the slider
 */
function goToNext() {
  // Set next index
  let nextIndex = window.currentIndex + 1;

  // Reset to 0 on overflow
  if (nextIndex >= slides.length) {
    nextIndex = 0;
  }

  // Change active item
  window.currentIndex = changeActiveImage(nextIndex);
}

/**
 * Go to the previous element in the slider
 */
function goToPrev() {
  // Set next index
  let nextIndex = window.currentIndex - 1;

  // Reset to 0 on overflow
  if (window.currentIndex === 0) {
    nextIndex = slides.length - 1;
  }

  // Change active item
  window.currentIndex = changeActiveImage(nextIndex);
}

// Add slider switching events
sliderSwitches[0].addEventListener('click', goToPrev);
sliderSwitches[1].addEventListener('click', goToNext);

document.addEventListener('keydown', (event: KeyboardEvent) => {
  if (event.key === 'ArrowLeft') {
    goToPrev();
    return;
  }
  if (event.key === 'ArrowRight') {
    goToNext();
    return;
  }
});

export default initSlider;
export { positionCloseButton };
